/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
import produce from "immer";
import {
  GET_SKUS_BY_IDS_REQUEST,
  GET_SKUS_BY_IDS_SUCCESS,
  GET_SKUS_BY_IDS_FAILURE,
  GET_SKUS_REQUEST,
  GET_SKUS_SUCCESS,
  GET_SKUS_FAILURE,
  ADD_SKU_REQUEST,
  ADD_SKU_SUCCESS,
  ADD_SKU_FAILURE,
  UPDATE_SKU_REQUEST,
  UPDATE_SKU_SUCCESS,
  UPDATE_SKU_FAILURE,
  ADD_MULTI_SKU_REQUEST,
  ADD_MULTI_SKU_SUCCESS,
  ADD_MULTI_SKU_FAILURE
} from "src/actions/skuActions";
import _ from "lodash";

const initialState = {
  skus: [],
  loadingCreateSku: false,
  loadingCreateMultiSku: false,
  loading: false
};

const skuReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SKUS_BY_IDS_REQUEST: {
      return produce(state, (draft) => {
        draft.skus = [];
        draft.loading = true;
      });
    }

    case GET_SKUS_BY_IDS_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.skus = response;
        draft.loading = false;
      });
    }

    case GET_SKUS_BY_IDS_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case GET_SKUS_REQUEST: {
      return produce(state, (draft) => {
        draft.skus = [];
        draft.loading = true;
      });
    }

    case GET_SKUS_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.skus = response;
        draft.loading = false;
      });
    }

    case GET_SKUS_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case ADD_SKU_REQUEST: {
      return produce(state, (draft) => {
        draft.loadingCreateSku = true;
      });
    }

    case ADD_SKU_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.skus = draft.skus.concat(response);
        draft.loadingCreateSku = false;
      });
    }

    case ADD_SKU_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingCreateSku = false;
      });
    }

    case ADD_MULTI_SKU_REQUEST: {
      return produce(state, (draft) => {
        draft.loadingCreateMultiSku = true;
      });
    }

    case ADD_MULTI_SKU_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.skus = draft.skus.concat(response);
        draft.loadingCreateMultiSku = false;
      });
    }

    case ADD_MULTI_SKU_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingCreateMultiSku = false;
      });
    }

    case UPDATE_SKU_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case UPDATE_SKU_SUCCESS: {
      const {response} = action.payload;
      const updateSKU = _.map(state.skus, (i) => {
        if (i.id == response.id) return response;
        return i;
      });
      if (updateSKU !== undefined && updateSKU.length > 0) {
        return produce(state, (draft) => {
          draft.skus = updateSKU;
          draft.loading = false;
        });
      }
      return produce(state, (draft) => {
        draft.skus = [response];
        draft.loading = false;
      });
    }

    case UPDATE_SKU_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    default: {
      return state;
    }
  }
};

export default skuReducer;
